export default {
  uploadTaskAttachment: (token, taskId, file, content) => {
    var myHeaders = new Headers();
    myHeaders.append("X-File-Name", file.name);
    myHeaders.append("Authorization", `Bearer ${token}`);
    myHeaders.append("Content-Type", file.type);
    myHeaders.append("Cookie", "wrikeLocale=en; isWhitelabel=false");
    
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: content,
      redirect: 'follow'
    };
    
    fetch(`https://www.wrike.com/api/v4/tasks/${taskId}/attachments`, requestOptions)
      .then(res => res.json())
  },
};
